<div class="backdrop" aria-hidden="true">
  <div class="backdrop__base"></div>
  <div class="backdrop__pools" #pools></div>
  <div class="backdrop__grid" #grid></div>
  <canvas class="backdrop__canvas" #canvas></canvas>
  <div class="backdrop__vignette"></div>
</div>
